import { createFileRoute } from '@tanstack/react-router';

import { RouteGuard } from '../../lib/route-guard.js';

export const Route = createFileRoute('/product-categories')({
  component: () => <RouteGuard route="/product-categories" />,
});
